import styled, { keyframes } from 'styled-components';

import { HOME } from '@constants/routes';

const BackgroundAnimation = keyframes`
    0% { height: 0; }
    45% { height: 50%; }
    90% { height: 100%; }
`;

export const LoaderContainer = styled.div`
  width: 140px;
  height: 56px;
  position: relative;
  margin-left: auto;
  margin-right: auto;
  margin-top: calc(50vh - 23px);
`;

export const Background = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  z-index: 3;
  display: block;
  width: 100%;
  height: 100%;
  transition: 0s;
  overflow: hidden;
  background-image: url(${HOME}/fpay-logo-v1.svg);
  background-position: 0 100%;
  background-size: cover;
  background-repeat: no-repeat;
  animation: ${BackgroundAnimation} 1s ease-out infinite;
  -webkit-animation: ${BackgroundAnimation} 1s ease-out infinite;
`;

export const Image = styled.img`
  opacity: 0.3;
  z-index: 1;
`;
